import forumPages from './js/page/forum';

export default function () {
    const currentPage = document.querySelector('body').getAttribute('id');

    if (typeof forumPages[currentPage] !== 'undefined') {
        forumPages[currentPage]();
    }
}
